import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"color":"inherit"} }
const _hoisted_2 = { class: "w-100 d-flex justify-content-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "image py-5 d-flex justify-content-center align-items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-alt",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "small",
  style: {"padding":"14px"}
}
const _hoisted_9 = {
  key: 1,
  class: "small",
  style: {"padding":"14px"}
}
const _hoisted_10 = {
  key: 2,
  class: "d-flex w-100 justify-content-center my-1"
}
const _hoisted_11 = { class: "border border-info px-2 py-1 small rounded button-template w-100 text-center" }
const _hoisted_12 = { class: "bottom px-3 pb-2" }
const _hoisted_13 = { class: "time text-dark font-weight-bold small" }

import { DateTime } from "ts-luxon";
import Modal from "@/components/Modal.vue";
import { Template } from "@/types/templates";
import { MessageFilePayload } from "vue-advanced-chat";


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean },
    template: null,
    preview: null,
    values: null
  },
  emits: ["update:modelValue", "freeMemory"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "update:modelValue", payload: boolean): void;
	(e: "freeMemory"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	modelValue: boolean;
	template: Template;
	preview: Partial<MessageFilePayload> | null;
	values: Record<string, any>;
}



function handleClose() {
	emits("update:modelValue", false);
}
function formatHeaderText(text: string, type: string) {
	const result = text.split(/{{\d{1,2}}}/);
	return result.join(props.values?.[type] ?? "");
}
function formatBodyText(text: string, type: string) {
	const result = text.split(/{{\d{1,2}}}/);
	return result
		.reduce(
			(acc, curr, i) => acc + curr + ` ${props.values?.[type]?.[i] ?? ""} `,
			""
		)
		.trim();
}

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(Modal, {
    show: __props.modelValue,
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.template?.name), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_card, {
          class: "w-50",
          "body-style": { padding: '0px' }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.template.components, (component) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: component.type
              }, [
                (component.type === 'HEADER')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (component.format === 'IMAGE')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "image",
                            src: __props.preview?.localUrl ?? '/img/theme/image.png',
                            alt: "Preview image",
                            onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('freeMemory')))
                          }, null, 40, _hoisted_3))
                        : (component.format === 'VIDEO')
                          ? (_openBlock(), _createElementBlock("video", {
                              key: 1,
                              class: "video",
                              src: __props.preview?.localUrl ?? '/img/theme/image.png',
                              autoplay: "",
                              alt: "Preview video",
                              onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('freeMemory')))
                            }, null, 40, _hoisted_4))
                          : (component.format === 'DOCUMENT')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                            : (component.format === 'TEXT')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("span", null, _toDisplayString(formatHeaderText(component.text, component.type)), 1)
                                ]))
                              : _createCommentVNode("", true)
                    ], 64))
                  : (component.type === 'BODY')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(formatBodyText(component.text, component.type)), 1)
                      ]))
                    : (component.buttons)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.buttons, (btn) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "mx-2 w-100",
                              key: btn.text
                            }, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(btn.text), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("time", _hoisted_13, _toDisplayString(_unref(DateTime).now().toFormat("hh:mm a")), 1)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})